var map = {
	"./editorBaseApi": [
		37970
	],
	"./editorBaseApi.js": [
		37970
	],
	"./editorSimpleWorker": [
		41122
	],
	"./editorSimpleWorker.js": [
		41122
	],
	"./editorWorker": [
		22143,
		2143
	],
	"./editorWorker.js": [
		22143,
		2143
	],
	"./editorWorkerHost": [
		70869
	],
	"./editorWorkerHost.js": [
		70869
	],
	"./findSectionHeaders": [
		97716
	],
	"./findSectionHeaders.js": [
		97716
	],
	"./getIconClasses": [
		45555,
		1613,
		5555
	],
	"./getIconClasses.js": [
		45555,
		1613,
		5555
	],
	"./languageFeatureDebounce": [
		26973,
		9570,
		6973
	],
	"./languageFeatureDebounce.js": [
		26973,
		9570,
		6973
	],
	"./languageFeatures": [
		33653,
		3653
	],
	"./languageFeatures.js": [
		33653,
		3653
	],
	"./languageFeaturesService": [
		50022,
		6611,
		5198
	],
	"./languageFeaturesService.js": [
		50022,
		6611,
		5198
	],
	"./languageService": [
		22155,
		1613,
		6611,
		2155
	],
	"./languageService.js": [
		22155,
		1613,
		6611,
		2155
	],
	"./languagesAssociations": [
		25709,
		1613,
		6611,
		5709
	],
	"./languagesAssociations.js": [
		25709,
		1613,
		6611,
		5709
	],
	"./languagesRegistry": [
		35074,
		1613,
		6611,
		5074
	],
	"./languagesRegistry.js": [
		35074,
		1613,
		6611,
		5074
	],
	"./markerDecorations": [
		86259,
		6259
	],
	"./markerDecorations.js": [
		86259,
		6259
	],
	"./markerDecorationsService": [
		72524,
		1422,
		6828
	],
	"./markerDecorationsService.js": [
		72524,
		1422,
		6828
	],
	"./model": [
		16911,
		6911
	],
	"./model.js": [
		16911,
		6911
	],
	"./modelService": [
		91320,
		1613,
		1422,
		1320,
		7229
	],
	"./modelService.js": [
		91320,
		1613,
		1422,
		1320,
		7229
	],
	"./resolverService": [
		55387,
		5387
	],
	"./resolverService.js": [
		55387,
		5387
	],
	"./semanticTokensDto": [
		7029,
		7029
	],
	"./semanticTokensDto.js": [
		7029,
		7029
	],
	"./semanticTokensProviderStyling": [
		4399,
		9570,
		4399,
		9729
	],
	"./semanticTokensProviderStyling.js": [
		4399,
		9570,
		4399,
		9729
	],
	"./semanticTokensStyling": [
		74566,
		4566
	],
	"./semanticTokensStyling.js": [
		74566,
		4566
	],
	"./semanticTokensStylingService": [
		28843,
		9570,
		4399,
		8843
	],
	"./semanticTokensStylingService.js": [
		28843,
		9570,
		4399,
		8843
	],
	"./textModelSync/textModelSync.impl": [
		43481
	],
	"./textModelSync/textModelSync.impl.js": [
		43481
	],
	"./textModelSync/textModelSync.protocol": [
		37619,
		7619
	],
	"./textModelSync/textModelSync.protocol.js": [
		37619,
		7619
	],
	"./textResourceConfiguration": [
		93533,
		3533
	],
	"./textResourceConfiguration.js": [
		93533,
		3533
	],
	"./treeSitterParserService": [
		47105,
		7105
	],
	"./treeSitterParserService.js": [
		47105,
		7105
	],
	"./treeViewsDnd": [
		29740,
		9740
	],
	"./treeViewsDnd.js": [
		29740,
		9740
	],
	"./treeViewsDndService": [
		95621,
		5621
	],
	"./treeViewsDndService.js": [
		95621,
		5621
	],
	"./unicodeTextModelHighlighter": [
		14818
	],
	"./unicodeTextModelHighlighter.js": [
		14818
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59135;
module.exports = webpackAsyncContext;